import { define } from "preactement";
import { ClubPage } from "./club/clubPage.tsx";
import { Summary } from "./club/summary.tsx";
import { HistoryPage } from "./club/historyPage.tsx";
import { PermissionsPage } from "./club/permissionsPage.tsx";
import { ApprovalRequestedFragment } from "./club/approvalRequestedFragment.tsx";

// APIs

define(Summary.tagName, () => Summary);
define(ApprovalRequestedFragment.tagName, () => ApprovalRequestedFragment);

// Pages

define(ClubPage.tagName, () => ClubPage);
define(HistoryPage.tagName, () => HistoryPage);
define(PermissionsPage.tagName, () => PermissionsPage);
